export default __webpack_public_path__ + "static/media/our-team-home2.1a770a3f.webp";